import { TActivityDeviceLog } from "../../../context/ActivityProvider";
import { cn, formatdDate } from "../../../lib/utils";
import { TooltipCell } from "../../table/TooltipCell";


type BodyTableDeviceProps = {
  rows: TActivityDeviceLog[];
};

export const BodyTableDeviceLogs = ({
  rows,
}: BodyTableDeviceProps): JSX.Element => {
  const baseCellClassName = cn(
    "p-[12px] typo-body-small-medium-14 text-black text-sm text-primary-light align-middle min-w-0",
  );

  return (
    <>
      {rows.map((activity: TActivityDeviceLog, index) => {
        return (
          <tr key={index}>
            <td className={cn(baseCellClassName)}>
              <TooltipCell content={activity?.actor} />
            </td>

            <td className={cn(baseCellClassName)}>
              <TooltipCell content={formatdDate(activity?.created_at) || '-'} />
            </td>

            <td className={cn(baseCellClassName)}>
              <TooltipCell content={activity?.device} />
            </td>

            <td className={cn(baseCellClassName)}>
              <TooltipCell content={activity?.event_type} />
            </td>
          </tr>
        );
      })}
    </>
  );
};
